import * as types from './user-groups.types';
import * as constants from './user-groups.constants';
import { IUserGroup, IUserGroupCreate } from '../../../resource/user-group/user-group.types';

export const getUserGroups = (): types.IGetUserGroups => ({
  type: constants.GET_USER_GROUPS,
});

export const createUserGroup = (userGroup: IUserGroupCreate): types.ICreateUserGroup => ({
  type: constants.CREATE_USER_GROUP,
  payload: userGroup,
});

export const updateUserGroup = (id: IUserGroup['id'], name: IUserGroupCreate['name']): types.IUpdateUserGroup => ({
  type: constants.UPDATE_USER_GROUP,
  payload: {
    id,
    name,
  },
});

export const storeUserGroups = (userIds: IUserGroup['id'][]): types.IStoreUserGroups => ({
  type: constants.STORE_USER_GROUPS,
  payload: userIds,
});

export const clearUserGroups = (): types.IClearUserGroups => ({
  type: constants.CLEAR_USER_GROUPS,
});

export const deleteUserGroup = (id: IUserGroup['id']): types.IDeleteUserGroup => ({
  type: constants.DELETE_USER_GROUP,
  payload: id,
});
